import { get } from '../../api';
import { isResOk } from '../../helper/is-res-ok';
import { AppConfigDto } from '../../models/AppConfigModel';
import { ConfigurationActionTypes, ReducerAction } from './actions';

async function getAllConfigurationData() {
    const result = await get<AppConfigDto[]>(`appconfigs`);

    if (isResOk(result.status)) {
        return result.data;
    } else {
        return null;
    }
}

async function getConfigurationData(configName: string) {
    const result = await get<AppConfigDto>(`appconfigs/by-name/${configName}`);

    if (isResOk(result.status)) {
        return result.data;
    } else {
        return null;
    }
}

async function setAllConfiguration(dispatch: React.Dispatch<ReducerAction>) {
    dispatch({
        type: ConfigurationActionTypes.SetConfiguration,
        payload: await getAllConfigurationData()
    });
}

async function setConfiguration(
    dispatch: React.Dispatch<ReducerAction>,
    type: ConfigurationActionTypes,
    configName: string
) {
    dispatch({
        type,
        payload: await getConfigurationData(configName)
    });
}

export { getAllConfigurationData, getConfigurationData, setConfiguration, setAllConfiguration };
